import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SiteTerminologyContent from "./SiteTerminologyContent";

const SiteTerminology = ({ state, dispatch }) => {
	const { appId } = useParams();
	const { t } = useTranslation();

	const [is404] = useState(false);

	if (is404 === false) {
		return (
			<SiteTerminologyContent
				state={state}
				dispatch={dispatch}
				scope={{ level: "siteapp", id: Number(appId) }}
			/>
		);
	} else {
		return (
			<p>{t("message.applicationIdDoesNotExist", { id: appId })}</p>
		);
	}
};

export default SiteTerminology;
